module.exports = "/images/io.svg?7988b63862437806a8e25d6aa3126e01";